import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ErrorBoundary } from './src/components/ui/ErrorBoundary';
import { ToastProvider } from './src/context/ToastContext';
import { ThemeProvider } from './src/context/ThemeContext';
import { LocaleProvider } from './src/context/LocaleContext';
import { polyfillResizeObserver } from './utils/browser-compat';
import { logger } from './src/lib/logger-client';
import { installGoogleAnalytics } from './src/lib/analytics';
import './index.css';

installGoogleAnalytics();

// Initialize polyfills before app loads
polyfillResizeObserver().catch((err) => logger.error('Polyfill init failed', err));

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary onError={(err, info) => logger.error('[ErrorBoundary] crash', err, info)}>
      <BrowserRouter>
        <LocaleProvider>
          <ThemeProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </ThemeProvider>
        </LocaleProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);